import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
export let EChecklistTemplateItemRef;
(function (EChecklistTemplateItemRef) {
  EChecklistTemplateItemRef["PatientFormTemplate"] = "patient-form-template";
})(EChecklistTemplateItemRef || (EChecklistTemplateItemRef = {}));
export let EChecklistTemplateItemExpiresAtUnit;
(function (EChecklistTemplateItemExpiresAtUnit) {
  EChecklistTemplateItemExpiresAtUnit["Day"] = "days";
  EChecklistTemplateItemExpiresAtUnit["Week"] = "weeks";
  EChecklistTemplateItemExpiresAtUnit["Month"] = "months";
  EChecklistTemplateItemExpiresAtUnit["Year"] = "years";
})(EChecklistTemplateItemExpiresAtUnit || (EChecklistTemplateItemExpiresAtUnit = {}));
export let EChecklistTemplateType;
(function (EChecklistTemplateType) {
  EChecklistTemplateType["Appointment"] = "appointment";
})(EChecklistTemplateType || (EChecklistTemplateType = {}));
export const fieldsChecklistTemplate = _extends({}, fieldsIBaseModel, {
  enabled: {
    type: 'Boolean'
  },
  filters: {
    type: 'Object',
    array: true
  },
  filtersCount: {
    type: 'Object'
  },
  items: {
    type: 'Object',
    array: true
  },
  name: {
    type: 'Text'
  },
  tag: {
    type: 'Text'
  },
  type: {
    type: 'Option',
    values: EChecklistTemplateType
  }
});